import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import img1 from "../../img/dots-1.png";
import ProjectCard from './ProjectCard';
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

const ProjectSlider = () => {
    const arrayProject = [
        {
            id: 4,
            tag: "Health, Management", 
            title: "SigmaCare Hospital",
            des: "SomeThig About Website",
            live: "https://sigmacare-hospital.netlify.app/",
            client:"https://github.com/developerfarid/sigma-hospital-client",
            server:"https://github.com/developerfarid/sigma-hospital-server",
            img: "https://i.ibb.co/CWmTGGR/screencapture-sigmacare-hospital-netlify-app-home-2022-03-20-11-54-21-1.png",
            tec:["React", "Express", "MongoDB", "React-Bootstrap", "React Hook Form", "Socket-io"]
            
            
        },
        {
            id: 11,
            tag: "Portfilo, Landing Page, Creative", 
            title: "Scelebration",
            des: "SomeThig About Website",
            live: "https://scelebration.netlify.app/",
            client:"https://github.com/developerfarid/Scelebration",
            img: "https://i.ibb.co/6g0gpmf/screencapture-scelebration-netlify-app-2022-04-20-16-26-48-1.png",
            tec:["React", "Tailwind CSS"]
            
            
        },
        {
            id: 12,
            tag: "e-commerce, Landing Page, Creative", 
            title: "Online Shop Only Design",
            des: "SomeThig About Website",
            live: "https://developerfarid.github.io/shop/",
            client:"https://github.com/developerfarid/shop",
            img: "https://i.ibb.co/tqPms30/screencapture-developerfarid-github-io-shop-2022-04-20-16-37-17-1-1.png",
            tec:["HTML", "SCSS", "jQary", "Animation"]
            
            
        },
    {
        id: 1,
        tag: "Health, e-commerce",
        title: "Health Care Website",
        des: "SomeThig About Website",
        live: "https://healthcare-developerfarid.web.app/",
        client: "https://github.com/developerfarid/health-care-website",
        img: "https://i.ibb.co/zsz2rbZ/screencapture-healthcare-developerfarid-web-app-2022-03-20-12-01-02-min.png",
        tec:["React", "React-Bootstrap", "React Hook Form", "React Router"]
        
    },
    {
        id: 2,
        tag: "e-commerce , business-site ",
        title: "Motor Bike",
        des: "SomeThig About Website",
        live: "https://honda-cbr-bootstrap-assignment-developerfarid.netlify.app/",
        client: "https://github.com/developerfarid/honda-html-css",
        img: "https://i.ibb.co/m9Q2DXj/screencapture-honda-cbr-bootstrap-assignment-developerfarid-netlify-app-2022-01-06-17-37-17.png",
        tec:["HTML", "CSS", "Media Quary", "BootStrap"]
        
        
    },
    {
        id: 3,
        tag: "e-commerce , shoe",
        title: "Online Shoe Shop",
        des: "SomeThig About Website",
        live: "https://newassinment.web.app/",
        client: "https://github.com/developerfarid/done-new",
        server:"https://github.com/developerfarid/done-new-server",
        img: "https://i.ibb.co/qFxRFtB/screencapture-newassinment-web-app-2022-03-20-12-09-52-1.png",
        tec:["React", "Express", "MongoDB", "React-Bootstrap", "React Hook Form"]
        
        
    },
  
    {
        id: 5,
        tag: "Landing Page , App",
        title: "Damox App Landing Page",
        des: "SomeThig About Website",
        live: "https://developerfarid.github.io/morix-full-website/",
        client: "https://github.com/developerfarid/morix-full-website",
        img: "https://i.ibb.co/ChBKSx2/screencapture-developerfarid-github-io-morix-ful01-13-18-22-06.png",
        tec:["HTML", "CSS", "Bootstrap", "jQuary", "Javascript"]
        
        
        
    },
    {
        id: 6,
        tag: "Landing Page , App",
        title: "Morix App Landing Page",
        des: "SomeThig About Website",
        live: "https://developerfarid.github.io/morix/",
        client:"https://github.com/developerfarid/morix",
        img: "https://i.ibb.co/Npmghvy/screencapture-developerfarid-github-io-morix-2022-01-06-17-43-19.png",
        tec:["HTML", "CSS", "Bootstrap", "jQuary", "Media Quary"]
    },
    {
        id: 7,
        tag: "Live Score" ,
        title: "Live Football  Score",
        des: "SomeThig About Website",
        live: "https://developerfarid.github.io/live-footboll-update/",
        client:"https://github.com/developerfarid/live-footboll-update",
        img: "https://i.ibb.co/MGK1Mhg/screencapture-developerfarid-github-io-live-footboll-update-2022-01-13-17-12-30.png",
        tec:["HTML", "CSS"]    
    },
    {
        id: 8,
        tag: "e-commerce , business site",
        title: "Honda Online sell BD",
        des: "SomeThig About Website",
        live: "https://honda-cbr-bootstrap-assignment-developerfarid.netlify.app/",
        client:"https://github.com/developerfarid/honda-html-css",
        img: "https://i.ibb.co/WDy1d5L/screencapture-honda-cbr-bootstrap-assignment-developerfarid-netlify-app-2022-01-06-17-37-17.png",
        tec:["HTML", "CSS", "Bootstrap"]   
    },
    {
        id: 9,
        tag: "business site",
        title: "Honda Online sell BD",
        des: "SomeThig About Website",
        live: "https://developerfarid.github.io/section-001/",
        client:"https://github.com/developerfarid/section-001",
        img: "https://i.ibb.co/yffhpfP/screencapture-developerfarid-github-io-section-001-2022-03-20-12-25-36-1.png",
        tec:["HTML", "CSS", "Bootstrap", "jQuary"]    
    },
    {
        id: 10,
        tag: "e-commerce , Education",
        title: "Online Education Website",
        des: "SomeThig About Website",
        live: "https://developerfarid.github.io/project-02/",
        client:"https://github.com/developerfarid/project-02",
        img: "https://i.ibb.co/dDNC43Z/screencapture-developerfarid-github-io-project-02-2022-03-20-12-31-49-min.png",
        tec:["HTML", "CSS", "Bootstrap", "jQuary"]    
    },
    {
        id: 11,
        tag: "e-commerce , business site",
        title: "Online Course Sell BD",
        des: "SomeThig About Website",
        live: "https://mr-it-online-course.netlify.app/",
        client:"https://github.com/developerfarid/Mr-it-center",
        img: "https://i.ibb.co/TwCj3V4/screencapture-mr-it-online-course-netlify-app-home-2022-03-20-12-17-10-1.png",
        tec:["React", "Bootstrap", "React Hook Form", "React Router"]  
    },
    {
        id: 14,
        tag: "Portfolio, Creative",
        title: "Creative Portfolio Website",
        des: "SomeThig About Website",
        live: "https://jovial-morse-2e135c.netlify.app/",
        client:"https://github.com/developerfarid/perfect-evos",
        img: "https://i.ibb.co/68J8GFB/screencapture-jovial-morse-2e135c-netlify-app-2022-04-20-16-47-52.png",
        tec:["HTML", "Bootstrap", "CSS", "jQuary", "Animation"]  
    }
]

    return (
        <Container style={{ color: "white" }}>
            <Row>
                <Col>
                    <div className="project-title">
                        <p>MY CLIENT</p>
                        <h3>Project</h3>
                        <img className='img-fluid' src={img1} alt="" />
                </div>
                </Col>
            </Row>
            <Swiper slidesPerView={3} spaceBetween={20} slidesPerGroup={1} loop={true} loopFillGroupWithBlank={true} pagination={{
                "clickable": true,
                "type": "progressbar"
            }} breakpoints={{
                "0": {
                  "slidesPerView": 1,
                  "spaceBetween": 20
                },
                "992": {
                  "slidesPerView": 2,
                  "spaceBetween": 20
                },
                "1224": {
                  "slidesPerView": 3,
                  "spaceBetween": 25
                }
              }} navigation={true} className="mySwiper">
            {arrayProject.map(item =><SwiperSlide> <ProjectCard key={item.id} project={item} /></SwiperSlide>)}
            </Swiper>
        </Container>
    );
};

export default ProjectSlider;